// extracted by mini-css-extract-plugin
export default {"inputFileBook":"styles_inputFileBook__H0zJp"};